/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_For_Candidates_DescInputs */

const en_stats_for_candidates_desc = /** @type {(inputs: Stats_For_Candidates_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile, CV check & applications`)
};

const de_stats_for_candidates_desc = /** @type {(inputs: Stats_For_Candidates_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil, CV-Check & Bewerbungen`)
};

/**
* | output |
* | --- |
* | "Profile, CV check & applications" |
*
* @param {Stats_For_Candidates_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const stats_for_candidates_desc = /** @type {((inputs?: Stats_For_Candidates_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_For_Candidates_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_stats_for_candidates_desc(inputs)
	return en_stats_for_candidates_desc(inputs)
});